module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ce988a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/forms/Form.vue.html
// module id = VSXt
// module chunks = 2